import styled from '@emotion/styled'
import { Colors, FontSizes, Gutter } from '../../utils/styles'

const headingFontWeight = 700
const color = Colors.BLACK

export const H1 = styled.h1({
  color,
  fontSize: 42,
  fontWeight: headingFontWeight,
  letterSpacing: '-0.5px',
  lineHeight: '54px',
  marginBottom: Gutter.HALF,
})

export const H2 = styled.h2({
  color,
  fontSize: 32,
  fontWeight: headingFontWeight,
  letterSpacing: '-0.4px',
  lineHeight: '40px',
  marginBottom: Gutter.HALF,
})

export const H3 = styled.h3({
  color,
  fontSize: 28,
  fontWeight: headingFontWeight,
  letterSpacing: '-0.3px',
  lineHeight: '34px',
  marginBottom: Gutter.HALF,
})

export const H4 = styled.h4({
  color,
  fontSize: FontSizes.LARGE,
  fontWeight: headingFontWeight,
  letterSpacing: '-0.2px',
  lineHeight: 1.6,
  marginBottom: Gutter.HALF,
})

export const H5 = styled.h4({
  color,
  fontSize: FontSizes.NORMAL,
  fontWeight: headingFontWeight,
  letterSpacing: '-0.1px',
  lineHeight: 1.5,
  marginBottom: Gutter.HALF,
})
